import { useState, useEffect } from "react";

export const useAudioPlayer = () => {
  const [audio, setAudio] = useState<HTMLAudioElement | null>(null);
  const [playing, setPlaying] = useState(false);
  const [isEnded, setIsEnded] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  const togglePlay = async () => {
    if (!audio || !isLoaded) return;

    try {
      if (!playing) {
        await audio.play();
      } else {
        audio.pause();
      }
      setPlaying(!playing);
    } catch (error) {
      console.error("Error playing audio:", error);
      setPlaying(false);
    }
  };

  const stopPlay = async () => {
    if (!audio) return;
    try {
      audio.pause();
    } catch (error) {
      console.error("Error playing audio:", error);
      setPlaying(false);
    }
  };

  useEffect(() => {
    if (audio) {
      const handleCanPlay = () => {
        setIsLoaded(true);
      };

      const handleEnded = () => {
        setIsEnded(true);
        setPlaying(false);
      };

      audio.addEventListener("canplay", handleCanPlay);
      audio.addEventListener("ended", handleEnded);

      // Preload the audio
      audio.load();

      return () => {
        audio.removeEventListener("canplay", handleCanPlay);
        audio.removeEventListener("ended", handleEnded);
      };
    }
  }, [audio]);

  return {
    togglePlay,
    stopPlay,
    playing,
    isEnded,
    setAudio,
    audio,
    isLoaded,
  };
};
